import React from "react";
import { CallToAction } from "components/CallToAction";
import { FA } from "components/FA";
import { openTopicFormModal } from "./TopicForm";
import styles from "./TopicSelector.module.css";

const TopicSelector = ({
  value = "none",
  topics = [],
  onTopicSelect,
  onTopicDelete,
  right = true,
}) => {
  const topicActions = topics.map((topic) => ({
    value: topic.id,
    label: topic.name,
    action: () => onTopicSelect(topic),
  }));
  topicActions.unshift({
    value: "none",
    label: "Uncategorized",
    action: () => onTopicSelect(null),
  });
  const currentActions = [
    {
      value: "new-topic",
      label: "Create Topic",
      icon: "folder-plus",
      action: () => openTopicFormModal(),
    },
  ];
  if (value !== "none") {
    currentActions.push({
      value: "edit-topic",
      label: `Edit`,
      icon: "edit",
      action: () => openTopicFormModal(value),
    });
    if (typeof onTopicDelete === "function") {
      currentActions.push({
        value: "delete-topic",
        label: `Delete`,
        icon: "trash",
        action: () => onTopicDelete(value),
      });
    }
  }
  return (
    <>
      <CallToAction
        size="sm"
        color="success"
        items={topicActions}
        value={value}
        right={right}
      />
      <CallToAction
        className={`${styles.action} cta`}
        size="sm"
        color="action"
        caret={false}
        items={currentActions}
        emptyLabel={<FA title="Click to select action" icon="ellipsis-v" />}
        right={right}
      />
    </>
  );
};

export { TopicSelector };
